import { SelectionWithAddressMixin } from './internal';
import { SelectionRecord } from './base';
import { SelectionWithNoteMixin } from './mixin';
export class SelectionRepositoryRecord extends SelectionWithAddressMixin(SelectionWithNoteMixin(SelectionRecord)) {
    getName() {
        return this.get("NAME" /* Tag.Name */);
    }
}
//# sourceMappingURL=SelectionRepositoryRecord.js.map